<div>
  <!-- Summary bar debajo del título -->
  <app-module-summary-bar [moduleTitle]="'COMMISSIONS MANAGEMENT'" [autoLoadDashboard]="false" [items]="summaryItems" [showPrimary]="false" [showSecondary]="false"></app-module-summary-bar>

  <!-- ═══ SINGLE UNIFIED TOOLBAR ROW ═══ -->
  <div class="flex flex-row items-end px-1 w-full justify-content-between">
    <!-- LEFT: Search -->
    <div class="flex-1 min-w-0 xl:max-w-2xl">
      @if (viewMode !== LiquidationsViewMode.REFERRALS) {
        <app-search-input [placeholder]="'Search by Sales Rep...'" (searchChange)="onSearch($event)"></app-search-input>
      }
    </div>

    <!-- RIGHT: Context controls + Switcher -->
    <div class="view-toolbar-actions d-flex align-items-end" style="gap: 12px;">
      <!-- History-specific: Download Statement + Month selector -->
      @if (viewMode === LiquidationsViewMode.HISTORY && historyTab) {
        <app-button *appHasPermission="['liquidations', 'generateStatementReport']"
          [disabled]="historyTab.liquidations.items.length === 0 || historyTab.loadingReport"
          (onClick)="historyTab.downloadCommissionsReport()">
          {{ historyTab.loadingReport ? 'Loading...' : 'Download Statement' }}
        </app-button>
        <div style="width: 180px;">
          <app-select [source]="historyTab.months" [control]="historyTab.monthControl" [icon]="'fa fa-calendar'"></app-select>
        </div>
      }

      <!-- Referrals-specific: Date pickers + Liquidate button -->
      @if (viewMode === LiquidationsViewMode.REFERRALS && referralsTab) {
        <div *appHasPermission="['liquidations', 'create']" class="d-flex align-items-end gap-2">
          <app-custom-input class="p-0" label="START DATE" [control]="referralsTab.filter_start_date" type="datetime-local"></app-custom-input>
          <app-custom-input class="p-0" label="END DATE" [control]="referralsTab.filter_end_date" type="datetime-local"></app-custom-input>
          <app-button type="button" (onClick)="referralsTab.openCreateLiquidationModal()">Liquidate Referrers</app-button>
        </div>
      }

      <!-- Switcher (ALWAYS visible, never destroyed) -->
      <div class="view-switcher rounded-lg" role="group" aria-label="Toggle commissions view">
        <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === LiquidationsViewMode.TEAM" (click)="toggleView(LiquidationsViewMode.TEAM)" title="Team Commissions">
          <i class="fa fa-users"></i><span>Team</span>
        </button>
        <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === LiquidationsViewMode.REFERRALS" (click)="toggleView(LiquidationsViewMode.REFERRALS)" title="Pay Referrals">
          <i class="fa fa-share-alt"></i><span>Referrals</span>
        </button>
        <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === LiquidationsViewMode.HISTORY" (click)="toggleView(LiquidationsViewMode.HISTORY)" title="Commission History">
          <i class="fa fa-history"></i><span>History</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ═══ CONTENT VIEWS (grids only, no toolbars) ═══ -->
  @if (viewMode === LiquidationsViewMode.HISTORY) {
    <app-all-liquidations-tab [searchTerm]="searchTerm"></app-all-liquidations-tab>
  } @else if (viewMode === LiquidationsViewMode.TEAM) {
    <app-team-commissions-tab [searchTerm]="searchTerm"></app-team-commissions-tab>
  } @else if (viewMode === LiquidationsViewMode.REFERRALS) {
    <app-liquidate-referrers-tab></app-liquidate-referrers-tab>
  }
</div>